'use client';

import { useRef, useState } from 'react';

import PlayIcon from '@/fo/icons/base/icons/play.svg';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './HeroVideo.styles';

export function HeroVideo() {
  const slots = styles();
  const videoRef = useRef<HTMLVideoElement>(null);
  const [hasStarted, setHasStarted] = useState(false);

  const handlePlay = () => {
    const video = videoRef.current;
    if (!video) return;

    void video.play();
    setHasStarted(true);
  };

  return (
    <div
      className={slots.base()}
      id="intensive-nad"
    >
      <div className={slots.wrapper()}>
        <video
          ref={videoRef}
          className={slots.video()}
          src={staticMediaUrl(
            'landing/ie_intensive_nad/ESTHEDERM-INTENSIVE_NAD.mp4'
          )}
          poster={staticMediaUrl('landing/ie_intensive_nad/preview-video.png')}
          width={1920}
          height={1080}
          muted
          playsInline
          preload="none"
          controls={hasStarted}
          onPlay={() => setHasStarted(true)}
        />
        {!hasStarted && (
          <button
            type="button"
            className={slots.playButton()}
            onClick={handlePlay}
          >
            <PlayIcon className={slots.playIcon()} />
          </button>
        )}
      </div>
    </div>
  );
}
